export const isPhone = window.screen.width <= 578
